module.exports = __webpack_public_path__ + "static/media/eCommerce.0f2f57b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/eCommerce.svg
// module id = 325
// module chunks = 0